import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { DealerService } from "src/app/core/services/dealer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Store } from "src/app/shared/models/store";

@Component({
	selector: "app-dealer-venue-tools",
	templateUrl: "./dealer-venue-tools.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class DealerVenueToolsComponent implements OnInit {
	@Input() venueSelected: Store;
	@Output() venueSelectedChange = new EventEmitter<Store>();

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		public dealerService: DealerService,
		public userService: UserService,
		public venueService: OOVenueService
	) {}

	ngOnInit(): void {
		this.venueService.storeConfigurationArchiveGet(this.venueSelected.key);
		this.venueService.storeConfigurationLinkLogsGet(this.venueSelected.key);
	}

	onSave() {}
}
